import React from "react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nProvider";

export default function AtlasFinalCTA({ onRequestDemo }) {
  const { t } = useI18n();
  return (
    <section
      id="recursos"
      data-testid="atlas-final-cta"
      className="py-16 lg:py-24 bg-white"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
        <h2
          data-testid="final-cta-title"
          className="font-display text-3xl sm:text-4xl lg:text-[44px] font-extrabold text-slate-900 leading-tight"
        >
          <span className="text-[#6B46C1]">ATLAS</span> {t("finalCta.titleA")}{" "}
          <span className="text-slate-900">{t("finalCta.titleB")}</span>
        </h2>
        <p className="mt-5 text-slate-600 text-base sm:text-lg max-w-xl mx-auto">
          {t("finalCta.subtitle")}
        </p>

        <div className="mt-8 flex items-center justify-center">
          <Button
            data-testid="final-request-demo-btn"
            onClick={onRequestDemo}
            className="bg-[#6B46C1] hover:bg-[#553C9A] text-white rounded-lg px-8 h-12 text-base font-semibold shadow-lg shadow-purple-300/50"
          >
            {t("cta.requestDemo")}
          </Button>
        </div>
      </div>
    </section>
  );
}
